export const FORMAT = {
  DEFAULT_STRING: '\u2015',
  TRUTHY_STRING: '\u25cb',
  FALSY_STRING: '\u2015',
} as const
